// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8z-3";
export var contentContainer = "_8z-0";
export var editorContainer = "_8z-1";
export var quillInputForm = "_8z-2";
export var zoneDivider = "_8z-4";